import type {
  LocalAgentBridgeCancelRequest,
  LocalAgentBridgeLifecyclePayload,
  LocalAgentBridgeProgressPayload,
  LocalAgentBridgeRequest,
  LocalAgentBridgeResponse,
  LocalAgentSamplingRequest,
  LocalAgentSamplingResponse,
} from './local-agent-protocol'

export const LOCAL_AGENT_EVENT_NAMES = {
  request: 'videocut:local-agent:request',
  cancel: 'videocut:local-agent:cancel',
  progress: 'videocut:local-agent:progress',
  response: 'videocut:local-agent:response',
  lifecycle: 'videocut:local-agent:lifecycle',
  samplingRequest: 'videocut:local-agent:sampling-request',
  samplingResponse: 'videocut:local-agent:sampling-response',
} as const

export function createLocalAgentRequestEvent(
  detail: LocalAgentBridgeRequest,
): CustomEvent<LocalAgentBridgeRequest> {
  return new CustomEvent(LOCAL_AGENT_EVENT_NAMES.request, { detail })
}

export function createLocalAgentCancelEvent(
  detail: LocalAgentBridgeCancelRequest,
): CustomEvent<LocalAgentBridgeCancelRequest> {
  return new CustomEvent(LOCAL_AGENT_EVENT_NAMES.cancel, { detail })
}

export function createLocalAgentProgressEvent(
  detail: LocalAgentBridgeProgressPayload,
): CustomEvent<LocalAgentBridgeProgressPayload> {
  return new CustomEvent(LOCAL_AGENT_EVENT_NAMES.progress, { detail })
}

export function createLocalAgentResponseEvent(
  detail: LocalAgentBridgeResponse,
): CustomEvent<LocalAgentBridgeResponse> {
  return new CustomEvent(LOCAL_AGENT_EVENT_NAMES.response, { detail })
}

export function createLocalAgentLifecycleEvent(
  detail: LocalAgentBridgeLifecyclePayload,
): CustomEvent<LocalAgentBridgeLifecyclePayload> {
  return new CustomEvent(LOCAL_AGENT_EVENT_NAMES.lifecycle, { detail })
}

export function createLocalAgentSamplingRequestEvent(
  detail: LocalAgentSamplingRequest,
): CustomEvent<LocalAgentSamplingRequest> {
  return new CustomEvent(LOCAL_AGENT_EVENT_NAMES.samplingRequest, { detail })
}

export function createLocalAgentSamplingResponseEvent(
  detail: LocalAgentSamplingResponse,
): CustomEvent<LocalAgentSamplingResponse> {
  return new CustomEvent(LOCAL_AGENT_EVENT_NAMES.samplingResponse, { detail })
}
